/* Countdown for the urgency meter: counts down to the next block of N hours, counted from the visitor's local midnight. */
(function () {
  if (customElements.get('renoura-countdown')) return;

  var pad = function (n) {
    return String(n).padStart(2, '0');
  };

  class RenouraCountdown extends HTMLElement {
    connectedCallback() {
      this.cycle = (parseFloat(this.dataset.hours) || 24) * 3600000;
      this.tick();
      this.timer = setInterval(this.tick.bind(this), 1000);
    }

    disconnectedCallback() {
      clearInterval(this.timer);
    }

    tick() {
      var now = new Date();
      var midnight = new Date(now.getFullYear(), now.getMonth(), now.getDate()).getTime();
      var elapsed = (now.getTime() - midnight) % this.cycle;
      var left = Math.ceil((this.cycle - elapsed) / 1000);
      this.textContent = pad(Math.floor(left / 3600)) + ':' + pad(Math.floor((left % 3600) / 60)) + ':' + pad(left % 60);
    }
  }

  customElements.define('renoura-countdown', RenouraCountdown);
})();
